import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const endPoint = process.env.REACT_APP_API_URL;

export const getWallet = createAsyncThunk(
  "getWallet",
  async ({ owner_id }, thunkApi) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      const res = await axios.get(
        `${endPoint}/wallets/?user=${owner_id}`,
        config
      );
      return res.data[0];
    } catch (error) {
      return thunkApi.rejectWithValue(error.response.data);
    }
  }
);
